import type { I18nLocale } from '@ardoq/i18n';
import type { QueryBuilderQuery } from '@ardoq/api-types';
import { queryBuilderOperations } from '@ardoq/query-builder';
import type { ComponentSearchViewState } from 'viewpointBuilder/selectContextTab/types';
import type { ComponentsSearchCommands } from 'viewpointBuilder/selectContextTab/commands';
import type { SelectContextI18n } from '../getImprovedDatasetsPanelI18n';
import {
  getValidAdvancedSearchQuery,
  isAdvancedSearchMode,
} from './startQueryConversion';
import type { SelectContextFilters } from './types';

export const getAdvancedSearchRuleCount = (query: QueryBuilderQuery): number =>
  queryBuilderOperations.calculateNumberOfRulesInSubQuery(
    queryBuilderOperations.getSubqueryFromQuery(query)
  );

type ToSelectContextFiltersArgs = {
  searchState: ComponentSearchViewState;
  commands: ComponentsSearchCommands;
  i18nLocale: I18nLocale;
  i18n: SelectContextI18n;
  onOpenRulesModal: VoidFunction;
};

export const toSelectContextFilters = ({
  searchState,
  commands,
  i18nLocale,
  i18n,
  onOpenRulesModal,
}: ToSelectContextFiltersArgs): SelectContextFilters => {
  const { advancedSearchState, componentTypes } = searchState;

  if (isAdvancedSearchMode(searchState)) {
    const validQuery = getValidAdvancedSearchQuery(advancedSearchState);
    if (!validQuery) {
      return { mode: 'advanced', controls: null };
    }
    return {
      mode: 'advanced',
      controls: {
        rulesSummaryLabel: i18n.rulesSummary.ruleCount(
          getAdvancedSearchRuleCount(validQuery)
        ),
        editRulesButtonLabel: i18n.searchMode.editRulesButton,
        onEditRules: onOpenRulesModal,
      },
    };
  }

  return {
    mode: 'simple',
    title: i18n.searchMode.title,
    nameFilter: {
      label: i18n.searchMode.searchNameLabel,
      placeholder: i18n.searchMode.searchNamePlaceholder,
      value: searchState.componentName,
      onChange: commands.setComponentName,
      onClear: () => commands.setComponentName(''),
      i18nLocale,
    },
    typeFilter: {
      label: i18n.searchMode.componentTypeLabel,
      placeholder: i18n.searchMode.allComponents,
      value: searchState.componentType,
      onChange: commands.setComponentTypeName,
      componentTypes,
      i18nLocale,
    },
  };
};
